__turbopack_context__.v({
  "wrap": "painted-title-module__rEJLua__wrap",
});
